import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
const $ = require('jquery');
const {homepage} = networkList;
class Bill_details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'thead': [],
            'tbody': [],
            previlege_data: [],
            'ip_id': ''
        };
    }

    componentDidMount() {
        // alert(this.props.location.state)
        if (this.props.location.state != null && this.props.location.state != undefined && this.props.location.state != '') {
            this.setState({
                ip_id: this.props.location.state
            })
        } else {

            const params = new URLSearchParams(this.props.location.search);
            const nav_ip = params.get('nav_ip');
            console.log(nav_ip);
            if (nav_ip) {
                this.setState({
                    ip_id: nav_ip
                })
            } else {
                notification.error({
                    message: 'Failure',
                    description: 'Oops, something went wrong... Please try again.',
                    duration: 10,
                    top: 20,
                    right: 0
                });
            }
        }
        this.loadPage()
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
    }
    cancel = () => {
        this
            .props
            .history
            .push(`/worklist/track-bills`)
    }
    loadPage = () => {
        try {
            const { getBillTrackingDetails } = networkList;
            let tableHead = [];
            tableHead = [
                {
                    "key": 's_no',
                    'text': 'S.No.'
                }, {
                    "key": 'date_of_counselling',
                    'text': 'Date Of Counselling'
                }, {
                    "key": 'fc_number',
                    'text': 'FC Number'
                }, {
                    "key": 'form_name',
                    'text': 'Service Name'
                }, {
                    "key": 'counselled_amount',
                    'text': 'Counselled Amount (Rs.)'
                }, {
                    "key": 'counselled_by',
                    'text': 'Counselled BY'
                }, {
                    "key": 'payer_type',
                    'text': 'Payment Type',
                }
            ]
            this.setState((state) => ({ thead: tableHead, loadding: true }), () => {
                postService(getBillTrackingDetails, 'POST', {
                    "data": {
                        "ip_no": this.state.ip_id
                    }
                }).then(res => {
                    console.log('tat report detail:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        this.setState((state) => ({
                            umr_number: res.data.umr_number || '--',
                            ip_number: res.data.ip_number || '--',
                            age: res.data.age || '--',
                            name: res.data.name || '--',
                            gender: res.data.gender || '--',
                            phone_number: res.data.phone_number || '--',
                            tbody: res.data.counselling_data ? res.data.counselling_data : res.data,
                            'previlege_data': res['previlege_data'],
                            loadding: false
                        }));
                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops, something went wrong... Please try again.",
                        });
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }



    navigateTo(ip, service) {
        let { id, slug } = this.props.match.params;
        let { previlege_data, ip_id } = this.state;
        if (previlege_data.includes(service)) {
            // window.open(`/counselling/view-finanical-counselling?pid=${data.payment_type_id}&cid=${data.counselling_id}&fid=${data.form_type}`, '_blank', 'noopener,noreferrer');
            this.props
                .history
                .push(`${homepage}/counselling/view-finanical-counselling?rid=${ip}&nav_from=${id}&nav_ip=${ip_id}`);
        }

    }


    render() {
        let { thead, tbody, name, umr_number, ip_number, age, gender, phone_number, previlege_data } = this.state;
        return (
            <Spin spinning={this.state.loadding}>
                <div className="card m-5 bill-details">
                    <h1 className="text-heading text-center pt-5 pl-5 pr-5">{name}</h1>
                    <div className="row p-5">
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">UMR Number</p>
                            <p className="data-item">: {umr_number}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">IP Number </p>
                            <p className="data-item">: {ip_number}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Phone Number </p>
                            <p className="data-item">: {phone_number}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Age </p>
                            <p className="data-item">: {age}</p>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                            <p className="data-label">Gender </p>
                            <p className="data-item">: {gender}</p>
                        </div>

                    </div>
                    <div className="card-table table-responsive pb-5">
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    {thead.map((head, key) => {
                                        return (<td className="text-capitalize align-middle" key={key}>{head['text']}</td>)
                                    })}
                                </tr>
                            </thead>
                            {
                                tbody != ''
                                    ?
                                    <tbody>
                                        {tbody.map((body, key) => {
                                            return (<tr key={key} 
                                            //     style={{ 'cursor': 'pointer' }}
                                            //  onClick={this.navigateTo.bind(this, body, body['service_id'])}
                                             >

                                                {thead.map((head, Hkey) => {
                                                    if (head['key'] === 's_no') {
                                                        return (<td>{key + 1}</td>)
                                                    }

                                                    if (head['key'] === 'date_of_counselling') {
                                                        return (<td>{moment(body['date_of_counselling']).format('DD MMM YYYY')}</td>)
                                                    }

                                                    if (head['key'] === 'fc_number' && body['service_id'] && previlege_data.includes(body['service_id'])) {
                                                        return (<td key={key} className='pointer'>{body[head['key']] ? body[head['key']] : '--'}</td>);
                                                    }

                                                    return (
                                                        <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : '--'}</td>
                                                    )

                                                })
                                                }

                                            </tr>)
                                        })}
                                    </tbody>
                                    :
                                    <tbody>
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                <p className="no-data mb-0">No Data</p>
                                            </td>
                                        </tr>
                                    </tbody>
                            }
                            {/* <thead className="bg9">
                                <tr>
                                    <td className="text-capitalize">Date Of Counselling</td>
                                    <td className="text-capitalize">FC Number</td>
                                    <td className="text-capitalize">Form Name</td>
                                    <td className="text-capitalize">Counselled Amount (Rs.)</td>
                                    <td className="text-capitalize">Counselled BY</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>7th Feb 2020</td>
                                    <td className="text-capitalize">FCNumber12456</td>
                                    <td className="text-capitalize">Initial Counselling</td>
                                    <td>1,00,000.00</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                </tr>
                                <tr>
                                    <td>8th Feb 2020</td>
                                    <td className="text-capitalize">FCNumber12416</td>
                                    <td className="text-capitalize">Recounselling 1</td>
                                    <td>1,00,000.00</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                </tr>
                                <tr>
                                    <td>9th Feb 2020</td>
                                    <td className="text-capitalize">FCNumber16456</td>
                                    <td className="text-capitalize">Initial Counselling</td>
                                    <td>1,00,000.00</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                </tr>
                                <tr>
                                    <td>10th Feb 2020</td>
                                    <td className="text-capitalize">FCNumber12456</td>
                                    <td className="text-capitalize">Recounselling 2</td>
                                    <td>1,00,000.00</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                </tr>
                            </tbody> */}
                        </table>
                    </div>
                    <div className="row justify-content-center pb-5">
                        <button className="btn btn-success text-capitalize" onClick={this.cancel}>Cancel</button>
                    </div>
                </div>
            </Spin>
        )
    }
}
export default Bill_details